// extracted by mini-css-extract-plugin
export var contact = "Footer-module--contact--8236a";
export var container = "Footer-module--container--008b8";
export var copyright = "Footer-module--copyright--86933";
export var decor = "Footer-module--decor--27e2f";
export var lastRow = "Footer-module--lastRow--93d46";
export var logo = "Footer-module--logo--5bfa6";
export var programs = "Footer-module--programs--b2c2c";
export var relativeWrapper = "Footer-module--relativeWrapper--861e3";
export var row = "Footer-module--row--340f3";
export var social = "Footer-module--social--854ea";
export var wrapper = "Footer-module--wrapper--dda04";